import './PromoLinksButton.sass';

import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Button, List, ListItem } from '$uikit';
import { BottomSheet } from '$uikit/BottomSheet/BottomSheet';
import { IcCheck16 } from '$assets';
import { useTranslator } from '$hooks';
import { promoLinksActions, promoLinksSelector } from '$store/promoLinks';

export interface PromoLinksButtonProps {
  value: number[]; // пустой массив = все ссылки (фильтр выключен)
  onChange: (next: number[]) => void;
}

export const PromoLinksButton: FC<PromoLinksButtonProps> = ({ value, onChange }) => {
  const t = useTranslator();
  const dispatch = useDispatch();
  const { links } = useSelector(promoLinksSelector);
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState<number[]>([]);

  useEffect(() => {
    dispatch(promoLinksActions.loadLinks());
  }, [dispatch]);

  if (!links.length) {
    return null;
  }

  const label = t('statistics_pro_links_label', { defaultValue: 'Links' });
  const indicator = value.length
    ? String(value.length)
    : t('statistics_pro_links_all', { defaultValue: 'All' });

  const handleOpen = () => {
    setDraft(value);
    setOpen(true);
  };

  const toggle = (id: number) => {
    setDraft((prev) =>
      prev.includes(id) ? prev.filter((v) => v !== id) : [...prev, id],
    );
  };

  const handleApply = () => {
    onChange(draft);
    setOpen(false);
  };

  const handleReset = () => {
    onChange([]);
    setOpen(false);
  };

  return (
    <>
      <Button mode="secondary" size="extra-small" onClick={handleOpen}>
        {label} · {indicator}
      </Button>

      {open && (
        <BottomSheet
          title={t('statistics_pro_links_title', { defaultValue: 'Referral links' })}
          onClose={() => setOpen(false)}
          className="ActionBottomSheet"
          scroll={false}
        >
          <div className="ActionBottomSheet__content">
            <div className="PromoLinksButton__list">
              <List>
                <ListItem
                  indicator={!draft.length ? <IcCheck16 /> : null}
                  onClick={() => setDraft([])}
                >
                  {t('statistics_pro_links_all_links', { defaultValue: 'All links' })}
                </ListItem>
                {links.map((link) => (
                  <ListItem
                    key={link.id}
                    indicator={draft.includes(link.id) ? <IcCheck16 /> : null}
                    description={link.webUrl}
                    descriptionSingleLine
                    onClick={() => toggle(link.id)}
                  >
                    {link.name}
                  </ListItem>
                ))}
              </List>
            </div>
            <div className="ActionBottomSheet__footer PromoLinksButton__footer">
              <Button stretched onClick={handleApply}>
                {t('statistics_pro_apply', { defaultValue: 'Apply' })}
              </Button>
              <Button stretched mode="secondary" onClick={handleReset}>
                {t('statistics_pro_reset', { defaultValue: 'Reset' })}
              </Button>
            </div>
          </div>
        </BottomSheet>
      )}
    </>
  );
};
